<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'loudnew/newLoudMainDetails',title:'信息漏斗'},{title:'信息漏斗详情'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2"style="margin-left:20px">
                                    <h1>基本信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail35">
                                        <el-form :model="add" label-position="right" ref="bh" :inline="true"
                                                 class="demo-ruleForm h-formbLine h-formbLine1">
                                          <el-form-item label="区域"  prop='area' class="h-elformWrap-2">
                                            <brselect  category="show_area" v-model="add.areaName" :v="add.areaName" :clearable="true" :disabled="this.disabled" readonly/>
                                          </el-form-item>

                                          <el-form-item label="渠道"  prop='customerChannel' class="h-elformWrap-2">
                                            <brselect category="sales_region" v-model="add.customerChannel" :v="add.customerChannel" :clearable="true" :disabled="this.disabled" readonly/>
                                          </el-form-item>

                                          <el-form-item  label="地市" prop='city' class="h-elformWrap-2">
                                            <el-input v-model="add.city" :disabled="this.disabled" readonly>
                                            </el-input>
                                          </el-form-item>

                                          <el-form-item  label="项目名称" prop='projectName' class="h-elformWrap-2">
                                            <el-input v-model="add.projectName" :disabled="this.disabled">
                                            </el-input>
                                          </el-form-item>

                                          <el-form-item label="项目分类"  prop='probjectSorts' class="h-elformWrap-2">
                                            <brselect category="message_type" v-model="add.probjectSorts" :v="add.probjectSorts" :clearable="true" :disabled="this.disabled"/>
                                          </el-form-item>

                                          <el-form-item label="机会分类"  prop='chanceType' class="h-elformWrap-2">
                                            <brselect category="chance_type" v-model="add.chanceType" :v="add.chanceType" :clearable="true" :disabled="this.disabled"/>
                                          </el-form-item>

                                          <el-form-item label="跟单商类别"  prop='documentaryType' class="h-elformWrap-2">
                                            <brselect category="gendanshang" v-model="add.documentaryType" :v="add.documentaryType" :clearable="true" :disabled="this.disabled"/>
                                          </el-form-item>

                                          <el-form-item label="签约经销商" prop="agentName" class="h-elformWrap-2">
                                            <el-input v-model="add.agentName" :disabled="this.disabled">
                                            </el-input>
                                          </el-form-item>

                                          <el-form-item label="用户单位" prop="customerName" class="h-elformWrap-2">
                                            <el-input v-model="add.customerName" :disabled="this.disabled">
                                            </el-input>
                                          </el-form-item>
                                          <el-form-item label="场景"  prop='scenesType' class="h-elformWrap-2">
                                            <brselect category="loud_scene" v-model="add.scenesType" :v="add.scenesType" :clearable="true" :disabled="this.disabled"/>
                                          </el-form-item>

                                          <el-form-item label="节点"  prop='statusR' class="h-elformWrap-2">
                                            <brselect category="xinxi_jiedian" v-model="add.statusR" :v="add.statusR" :clearable="true" :disabled="this.disabled"/>
                                          </el-form-item>

                                          <el-form-item  label="子节点" prop='childMsgId' class="h-elformWrap-2">
                                            <el-input v-model="add.childMsgId" :disabled="this.disabled">
                                            </el-input>
                                          </el-form-item>

                                          <el-form-item label="预计挂网时间" :required="true" class="h-elformWrap-2">
                                            <el-input v-model="add.expOnlineDate" :disabled="this.disabled">
                                            </el-input>
                                          </el-form-item>

                                          <el-form-item label="中标时间" class="h-elformWrap-2">
                                            <el-input v-model="add.brandDate" :disabled="this.disabled">
                                            </el-input>
                                          </el-form-item>

                                          <el-form-item  label="中标品牌" prop='childMsgId' class="h-elformWrap-2">
                                            <el-input v-model="add.brandName" :disabled="this.disabled">
                                            </el-input>
                                          </el-form-item>

                                          <el-form-item  label="中标型号" prop='childMsgId' class="h-elformWrap-2">
                                            <el-input v-model="add.brandModel" :disabled="this.disabled">
                                            </el-input>
                                          </el-form-item>

                                          <el-form-item  label="中标价格" prop='childMsgId' class="h-elformWrap-2">
                                            <el-input v-model="add.brandPrice" :disabled="this.disabled">
                                            </el-input>
                                          </el-form-item>

                                          <el-form-item  label="海尔丢标分析" prop='childMsgId' class="h-elformWrap-2">
                                            <el-input v-model="add.delReason" :disabled="this.disabled">
                                            </el-input>
                                          </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                          <div class="h-rowBox ljjtablepaddings12" style="margin-top:30px;padding:0;">
                            <div class="h-rowCon" style="padding-bottom:0">
                              <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                <div class="h-pieceTitle2"
                                     style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                  <h1>产品信息</h1>
                                </div>
                              </div>
                              <el-table
                                  ref="multipleTable"
                                  @selection-change="handleSelectionChange"
                                  :data="add.products"
                                  stripe
                                  style="width: 100%"
                                  :border="true">
                                <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                                </el-table-column>
                                <el-table-column
                                    prop="lianqun"
                                    label="链群"
                                    width="%25">
                                  <template slot-scope="scope">
                                    <dictname category="xsyb_lianqun" :v="scope.row.lianqun"/>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                    prop="proModel"
                                    label="产品型号"
                                    width="%25">
                                  <template slot-scope="scope">
                                    {{scope.row.proModel}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                    prop="num"
                                    label="数量"
                                    width="%25">
                                  <template slot-scope="scope">
                                    {{scope.row.num}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                    prop="price"
                                    label="价格(万)"
                                    width="%25">
                                  <template slot-scope="scope">
                                    {{scope.row.price}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                    prop="price"
                                    label="总价(万)"
                                    width="%25">
                                  <template slot-scope="scope">
                                    {{scope.row.totalPrice}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </div>
                          <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
                            <div class="h-pieceTitle2 hang">
                              <h1 class="h1" style="margin-left:20px">漏斗审批</h1>
                                <div class="h-formLine weekplandetail35">
                                    <el-form :model="shenpi" label-position="right" :inline="true"
                                             class="demo-ruleForm h-formbLine " :rules="rules">
                                        <el-form-item label="审批意见" class="h-elformWrap-2" :required="true" style="margin-top:0.2rem;margin-left: 0.2rem;">
                                            <el-input v-model="shenpi.shenheyijian" placeholder="请输入"
                                                      :disabled="taskstatus==1" ></el-input>
                                        </el-form-item>
                                    </el-form>
                                </div>
                              <div class="h-txtCenter" style="margin-top: 0.3rem;">
                                <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="backL">返回</el-button>
                                <el-button class="h-btn h-bBtn h-bgred" @click="tongguobohui(2)"  v-if="taskstatus==0">驳回</el-button>
                                <el-button class="h-btn h-bBtn h-bggreen" @click="tongguobohui(1)"  v-if="taskstatus==0">通过</el-button>
                                <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
                              </div>

                            </div>
                        </div>
                    </div>


                </div>
            </div>
          <el-dialog :close-on-click-modal="false" :visible.sync="msgDataVisible" class="h-dialog2">
            <div class="h-formLine h-mrb-38" style="margin: 0.38rem 0 0 0;">
              <el-form :model="add" label-position="right" ref="bh" :inline="true"
                       class="demo-ruleForm h-formbLine h-formbLine1">
                <el-form-item label="变更原因" class="h-elformWrap-2" style="margin-left:0.5rem;">
                  <template slot-scope="scope">
                    {{scope.row.price}}
                  </template>
                </el-form-item>
                <br>
                <el-form-item label="变更附件" class="h-elformWrap-2" style="margin-left:0.5rem;">
                  <template slot-scope="scope">
                    {{scope.row.price}}
                  </template>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="delDataVisible = false">取 消</el-button>
              <el-button type="primary" @click="deleteAgainstUser">确 定</el-button>
            </div>
          </el-dialog>



        </div>
    </div>
</template>

<script>
    import checkblue from '../../../assets/images/h-image-checkblue.png'
    import checkblueAc from '../../../assets/images/h-imgCheckBox-icon.png'
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                q: {
                },
                add:{
                  id:null, // 主键ID
                  areaName:null,
                  projectId:null, // 项目id
                  projectName:null, // 需求名称
                  probjectSorts:null, // （CSW城市网，XM大项目，SD散单）
                  projectType:null, // 项目类型0内销1外销2采购3展会
                  statusR:null, // 节点  R0:方案交互  R1:需求锁定  R2:预算提报  R3:预算批准  R4:招标挂网  R5:转化收入 R6 已转化 R7 已丢标
                  expectConvertDate:null, // 报单日期
                  area:null, // 区域
                  customerChannel:null, // 渠道
                  city:null,//地市
                  customerCode:null, // 用户编码
                  customerName:null, // 客户名称
                  deptName:null, // 部门/科室
                  chargePerson:null, // 负责人
                  phone:null, // 电话
                  chanceType:null, // 机会分类
                  expOnlineDate:null, // 预计挂网时间
                  brandDate:null, // 中标时间
                  expConvDate:null, // 预计转化时间
                  documentaryType:null, // 跟单商别（直单/经销商/合伙人）
                  partner:null, // 合伙人名称
                  remark:null, // 备注
                  cucode:null, // 创建人编码
                  cuname:null, // 创建人名称
                  cdate:null, // 创建时间
                  lucode:null, // 更新人编码
                  ldate:null, // 最后更新时间
                  delflag:null, // 可用标志  1: 可用, 0: 不可用
                  brandModel:null,
                  delReason:null,
                  price:null,
                  num:null,
                  proCode:null,
                  scenesType:null,
                  updateStatus:null,
                  products:[{
                    lianqun:'',
                    price:'',
                    proModel:'',
                    proCode:'',
                    num:'',
                    totalPrice:'',
                  }],
                  lianqun:null,
                },
                shenpi:{
                  shenheyijian:'',
                },
                rddId: null,
                deptList: [],
                repList: [],
                instid: null,
                taskid: null,
                isCucode:false,
                showhistory:false,
                msgDataVisible:false,
                disabled :true,
                requireDate:null,
                taskstatus:null,
                tishi:null,
              rules: {
                shenheyijian: [
                  {required: true, message: '请填写必填项', trigger: 'blur'},
                ],
              }
            }
        },
        created() {
          var instId = this.$route.query.instid;
          this.getLoudMainByInstId(instId);
          this.taskstatus = this.$route.query.taskstatus;
          this.taskid = this.$route.query.taskid;
          //业务id
          // this.ywid = this.$route.query.ywid;
          this.instid = this.$route.query.instid;
        },

        mounted() {
            this.query();
        },
        methods: {
          query() {

          },
          updateDetail(row) {
            this.add = row
            this.$set(this.add, "id", row.id);
            ss.loudnew.getLoudById(row.id).then(rd => {
              this.add.products = rd.obj.products;
            })
          },
          backL() {
            this.$router.go(-1);
          },
          handleSelectionChange(val) {
            this.multipleSelection = val;
          },
          getLoudMainByInstId(row) {
            ss.loudnew.getLoudMainByInstId(row).then(rd => {
              console.log(rd);
              this.add = rd.obj
              this.add.products = rd.obj.products;
              let tishi = "签约经销商  :"+rd.obj.agentName+'<br/>'+ "用户单位:  "+rd.obj.customerName
              this.tishi = tishi
              this.$alert(this.tishi, '系统通知', {
                    confirmButtonText: '确定',
                    type:'warning',
                    dangerouslyUseHTMLString:true
                  });
              for(var i=0;i<this.add.products.length;i++){
                this.products.totalPrice = this.products.num * this.products.price;
                if(this.tableData[i].totalPrice != null && this.tableData[i].finishRate != ''){
                  const realVal = parseFloat(this.products[i].totalPrice).toFixed(2);
                  this.products[i].totalPrice = realVal;
                }
              }
            })
          },
          tongguobohui(row) {

            var shenPiEntity = {
              yewuzhujian: this.ywid,//业务主键
              taskid: this.taskid,//页面拿到的taskid
              msg: this.shenpi.shenheyijian,//  页面填写的审核意见
              jiediantiaojianming: 'a',//通过还是驳回的节点条件名字
              instid: this.instid,//选择要进入的审批版本id
              tongguoorbohui:row,
            }
            console.log(shenPiEntity)
            ss.loudnew.isqianyueloudPsaa(shenPiEntity).then(rd => {
              if(rd.f==true){
                this.$msg.alerts("提交成功！",()=>{
                  //刷新右上角的代办个数
                  this.$store.dispatch("searchTasktotal")
                  this.$router.push({path:'/personal/dealCenter'})
                })
              }

            })
          },
          viewpress(r){
            this.showhistory = true;
          },
        }
    }
</script>
<style scoped lang="scss">
    .y-container {
        width: 100%;

        .y_tabBar {
            display: flex;
            justify-content: flex-start;
            flex-wrap: nowrap;

            .eveBar {
                padding: 0.1rem 0.1rem 0.1rem 0.1rem;
                width: 1.85rem;
                height: 0.73rem;
                border: 1px solid #d9dfe9;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 0.16rem;
                position: relative;
                cursor: pointer;
                font-size: 0.18rem;
                color: #525252;

                &:last-child {
                    margin-right: 0;
                }

                .imgrigt {
                    margin-left: 0.08rem;
                }
            }

            .eveBarAc {
                background-color: #248bff;
                color: white;
            }

            .redCircle {
                width: 0.15rem;
                height: 0.15rem;
                background-color: #e64a19;
                position: absolute;
                top: -0.06rem;
                right: -0.06rem;
                border-radius: 50%;
            }
        }

        .containGrey {
            width: 100%;
            border: 1px solid #dedede;
            background-color: #f9f9f9;
            margin-top: 0.4rem;

            .containAll {
                padding: 0.3rem;
                max-height: 3.6rem;
                width: 100%;
                overflow-y: auto;
            }

            .dialogDiv {
                margin-bottom: 0.2rem;

                .timeTip {
                    color: #999999;
                    font-size: 0.14rem;
                    width: 100%;
                    text-align: center;
                    margin-bottom: 0.18rem;
                }

                .firstTalk {
                    display: flex;

                    .leftname {
                        font-size: 0.18rem;
                        color: #2a2a2a;
                    }

                    .containTalk {
                        font-size: 0.16rem;
                        color: #5e5e5e;
                        border: 1px solid #dedede;
                        background-color: white;
                        width: 7.1rem;
                        border-radius: 5px;
                        margin-left: 0.3rem;
                        padding: 0.2rem;
                        word-break: break-word;
                    }

                    .containTalk2 {
                        background-color: #e8e7e7;
                        margin-right: 0.3rem;
                        word-break: break-word;
                    }
                }

                .firstTalk2 {
                    flex-direction: row-reverse;
                }
            }

            .replyBox {
                padding: 0.2rem;
                border-top: 1px solid #dedede;
                display: flex;
                background-color: white;

                .tips {
                    font-size: 0.18rem;
                    color: #0072ed;
                    flex-shrink: 0;
                    margin-right: 0.15rem;
                }

                .replyBar {
                    position: relative;
                    width: 100%;

                    .relpyInput {
                        width: 100%;
                        height: 0.72rem;
                        border: none;
                        background-color: #FFFFFF;
                        outline: none;
                        padding: 0.08rem;
                        padding-top: 0.04rem;
                        resize: none;
                    }

                    .h-bgblueQ2 {
                        background-color: #2785e7;
                        color: white;
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        height: 0.46rem;
                        width: 1.1rem;
                        padding: 0;
                    }
                }
            }
        }

    }

    .loopClosed {
        width: 100%;
        display: flex;
        padding-bottom: 50px;
    }

    .loopClosed .loop {
        width: 30%;
        margin-left: 3%;
    }

    .loopClosed .loop:first-child {
        margin: 0;
    }

    .loopClosed .loop .title {
        font-size: 0.18rem;
        color: #0e75e9;
        font-weight: bold;
        border-left: 0.05rem solid #0e75e9;
        margin-bottom: 0.3rem;
        padding-left: 10px;
    }

    .loopClosed .loop .boxs {
        width: 100%;
        padding: 60px;
        box-sizing: border-box;
        border: 1px solid #e4e4e4;
        color: #868686;
        font-size: 0.16rem;
        margin-bottom: 0.3rem;
        border-radius: 3px;
    }

    .shenglue {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .loopClosed .loop .buttons {
        width: 145px;
        height: 55px;
        border: 1px solid #e4e4e4;
        border-radius: 3px;
        color: #323232;
        font-size: 0.16rem;
        text-align: center;
        line-height: 55px;
        margin-left: 50%;
        transform: translateX(-72px);
        cursor: pointer;
    }
</style>
<style>

    .weekplandetail35 .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .weekplandetail35 .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .weekplandetail35 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .weekplandetail35 .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .weekplandetail35 .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .weekplandetail35 .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }
</style>
<style scoped lang="scss">
    .bottomTip{
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
        z-index: 999999;
    }
    .newtext{
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top:0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow:1px 1px 4px #2785E7;
        z-index: 2;
    }
    .leaderBox{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
        .leaderbg{
            width: 100%;
            height: 100%;
        }
        .steps{
            position: absolute;
            z-index: 1;
        }
        .step1{
            top: 0;
            left: 0;
        }

        .stepbtn{
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0,0,0,0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.65rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }
        .closeIt{
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
            z-index: 2;
        }
      .el-textarea__inner{
        height: 26px;
        overflow-y: auto;
        /* overflow-y: auto;兼容ie  */
      }
    }
</style>
<style>

</style>
